import React, { Component, useState } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { Link, useHistory } from 'react-router-dom';
import { PostData } from '../../containers/Services/PostData';
import { ApiService } from '../../containers/Services/apiservice';
import LSHeader from '../../containers/LSHeader';
import { Helmet } from 'react-helmet';
import { Watch } from "react-loader-spinner";
let apiServices = new ApiService();
const Register = () => {
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [counter, setCounter] = React.useState(0);
    const [countermob, setCountermob] = React.useState(0);
    const [registerData, setRegisterData] = useState({ user_email: '', email_otp: '', mobile_no: '', mobile_otp: '', cnfpassword: '', password: '', agentcode: '' });
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [showLoading, setShowLoading] = useState(false);
    const [userId, setUserId] = useState(0);
    const [step1, setStep1] = useState(true);
    const [step2, setStep2] = useState(false);
    const [step3, setStep3] = useState(false);
    const [step4, setStep4] = useState(false);
    const [step5, setStep5] = useState(false);
    const [passwordstatus, setpasswordstatus] = useState(true);
    const [seconds, setseconds] = useState(0);
    const [minutes, setminutes] = useState(10);
    const [secondsmob, setsecondsmob] = useState(0);
    const [minutesmob, setminutesmob] = useState(10);
    const [salcode, setsalcode] = useState(0);
    const [SYSTEMMAINTAINANCE, SETSYSTEMMAINTAINANCE] = useState(0);
    let history = useHistory();
    // componentDidMount() {
    // }
    const handleInput = (e) => {
        const key = e.target.name;
        const value = e.target.value;
        setRegisterData({ ...registerData, [key]: value })
        if (key == 'password') {
            checkspecialchar(value);
            checkcapsmall(value);
            checkminchar(value);
        }
    }
    React.useEffect(() => {
        setTimeout(() => {
            if (seconds > 0) {
                setseconds(seconds - 1)
            }
            if (seconds === 0) {
                if (minutes === 0) {
                } else {
                    setseconds(59)
                    setminutes(minutes - 1)
                }
            }
        }, 1000)
    });
    //   React.useEffect(() => {
    //     setTimeout(() => {
    //         if (secondsmob > 0) {
    //             setsecondsmob(secondsmob-1)
    //         }
    //         if (secondsmob === 0) {
    //             if (minutesmob === 0) {
    //             } else {
    //                 setsecondsmob(59)
    //                 setminutesmob(minutesmob-1)
    //         } 
    //     }
    //     }, 1000)
    //   });

    React.useEffect(() => {
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }, [counter]);

    React.useEffect(() => {
        countermob > 0 && setTimeout(() => setCountermob(countermob - 1), 1000);
    }, [countermob]);

    function checkminchar(e) {
        var a = document.getElementById('minchar');
        if (e.length > 8) {
            a.setAttribute("class", "text mg-b-5 tx-11 text-success");
            return true;
        }
        else {
            a.setAttribute("class", "text mg-b-5 tx-11 text-danger");
            return false;
        }
    }
    function checkcapsmall(e) {
        var cap = document.getElementById('capsmall');
        var pattern = new RegExp("^(?=.*[a-z])(?=.*[A-Z]).+$");
        if (e.match(pattern)) {
            cap.setAttribute("class", "text mg-b-5 tx-11 text-success");
            return true;
        }
        else {
            cap.setAttribute("class", "text mg-b-5 tx-11 text-danger");
            return false;
        }
    }
    function checkspecialchar(e) {
        var special = document.getElementById('specialchar');
        var pattern2 = new RegExp("^(?=.*[-+_!@#$%^&*.,?]).+$");
        if (e.match(pattern2)) {
            special.setAttribute("class", "text mg-b-5 tx-11 text-success");
            return true;
        }
        else {
            special.setAttribute("class", "text mg-b-5 tx-11 text-danger");
            return false;
        }
    }
    function isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    }
    const firstStep = (e) => {
        e.preventDefault();
        setSpinnerLoading(true);
        if (registerData.user_email == '') {
            setErrorMessage("Email Address cannot Be Empty");
            setSpinnerLoading(false);
            return false;
        }
        else if (!isValidEmail(registerData.user_email)) {
            setErrorMessage('Please Enter Valid Email Address');
            setSpinnerLoading(false);
            return false;
        }
        else {
            setErrorMessage('');
            const dataString = {
                "user_email": registerData.user_email,
                "step": 1,
            }
            setShowLoading(true);
            apiServices.registerPostRequest(dataString).then(result => {
                if (result.data.status == 'success') {
                    // localStorage.setItem('user', JSON.stringify(res.data.data));
                    setStep1(false);
                    setStep2(true);
                    setStep3(false);
                    setStep4(false);
                    setStep5(false);
                    setUserId(result.data.auth);
                    setSuccessMessage(result.data.message);
                    setSpinnerLoading(false);
                    setCounter(30)
                }
                else {
                    setErrorMessage(result.data.message);
                    setSpinnerLoading(false);
                }
                setShowLoading(false);
            })
                .catch(error => {

                })
        }
    };
    const resendotp = (e) => {
        e.preventDefault();
        const dataString = {
            "id": userId,
            "type": 'email'
        }
        apiServices.resendotpPostRequest(dataString).then(result => {
            if (result.data.status == 'success') {
                setCounter(30)
                setminutes(10);
                setseconds(0);
                return false;
            }
            else {
                setErrorMessage(result.data.message);
            }
            setShowLoading(false);
        })
            .catch(error => {
            })
    };
    const resendotpmobile = (e) => {
        e.preventDefault();
        const dataString = {
            "id": userId,
            "type": 'mobile'
        }

        apiServices.resendotpPostRequest(dataString).then(result => {
            if (result.data.status == 'success') {
                setCountermob(30)
                setminutes(10);
                setseconds(0);
                return false;
            }
            else {
                setErrorMessage(result.data.message);
            }
            setShowLoading(false);
        })
            .catch(error => {

            })

    };
    const backToEmail = (e) => {
        setStep1(true);
        setStep2(false);
        setStep3(false);
        setStep4(false);
        setStep5(false);
        setCounter(0)
    }
    const backToMobile = (e) => {
        setStep1(false);
        setStep2(false);
        setStep3(true);
        setStep4(false);
        setStep5(false);
        setCountermob(0)
    }
    const secondStep = (e) => {
        e.preventDefault();
        setSpinnerLoading(true);
        if (registerData.email_otp == '') {
            setErrorMessage("Pleast Enter OTP");
            setSpinnerLoading(false);
        } else {
            setErrorMessage('');
            const dataString = {
                "otp": registerData.email_otp,
                "id": userId,
                "step": 2,
            }
            apiServices.registerPostRequest(dataString).then(result => {
                if (result.data.status == 'success') {
                    // localStorage.setItem('user', JSON.stringify(res.data.data));
                    setStep1(false);
                    setStep2(false);
                    setStep3(true);
                    setStep4(false);
                    setStep5(false);
                    setSpinnerLoading(false);
                    setSuccessMessage(result.data.message);
                }
                else {
                    setErrorMessage(result.data.message);
                    setSpinnerLoading(false);
                }
            })
                .catch(error => {

                })
        }
    };
    const thirdStep = (e) => {
        e.preventDefault();
        setSpinnerLoading(true);
        if (registerData.mobile_no == '') {
            setErrorMessage("Pleast Enter Mobile Number");
            setSpinnerLoading(false);
            return false;
        }
        else if (registerData.mobile_no.length != 10) {
            setErrorMessage("Pleast Enter Valid Mobile Number");
            setSpinnerLoading(false);
            return false;
        }
        else {
            setErrorMessage('');
            const dataString = {
                "mobile_no": registerData.mobile_no,
                "id": userId,
                "step": 3,
            }
            apiServices.registerPostRequest(dataString).then(result => {
                if (result.data.status == 'success') {
                    // localStorage.setItem('user', JSON.stringify(res.data.data));
                    setStep1(false);
                    setStep2(false);
                    setStep3(false);
                    setStep4(true);
                    setStep5(false);
                    setSuccessMessage(result.data.message);
                    setSpinnerLoading(false);
                    setCountermob(30)
                    // setminutes(10);
                    // setseconds(0);
                }
                else {
                    setErrorMessage(result.data.message);
                    setSpinnerLoading(false);
                }
            })
                .catch(error => {
                })
        }
    };
    const forthStep = (e) => {
        e.preventDefault();
        setSpinnerLoading(true);
        if (registerData.mobile_otp == '') {
            setErrorMessage("Pleast Enter Mobile OTP");
            setSpinnerLoading(false);
            return false;
        } else {
            setErrorMessage('');
            const dataString = {
                "mobile_otp": registerData.mobile_otp,
                "id": userId,
                "step": 4,
            }
            PostData('register', dataString).then((result) => {
                if (result.status == 'success') {
                    setStep1(false);
                    setStep2(false);
                    setStep3(false);
                    setStep4(false);
                    setStep5(true);
                    setSpinnerLoading(false);
                    // setSuccessMessage(result.message);
                } else {
                    setErrorMessage(result.message);
                    setSpinnerLoading(false);
                }
            });
        }
    };
    const setsalescode = (e) => {
        if (salcode == 0) { setsalcode(1) } else {
            setsalcode(0);
        }
    }
    const fifthStep = (e) => {
        e.preventDefault();
        setSpinnerLoading(true);

        if (registerData.password == '' || registerData.cnfpassword == '') {
            setErrorMessage("Pleast Enter The Credentials");
            setSpinnerLoading(false);
            return false;
        } else if (registerData.password != registerData.cnfpassword) {
            setErrorMessage("Password and Confirm Password is incorrect");
            setSpinnerLoading(false);
            return false;
        } else {
            if (checkspecialchar(registerData.password) && checkcapsmall(registerData.password) && checkminchar(registerData.password)) {
                setErrorMessage('');
                const dataString = {
                    "id": userId,
                    "confirm_password": registerData.cnfpassword,
                    "password": registerData.password,
                    "agentcode": registerData.agentcode,

                    "step": 5,
                }
                apiServices.registerPostRequest(dataString).then(result => {
                    if (result.data.status == 'success') {

                        localStorage.setItem('AUTH_TOKEN', result.data.auth_token);
                        setStep1(false);
                        setStep2(false);
                        setStep3(false);
                        setStep4(false);
                        setStep5(true);
                        setSuccessMessage(result.data.message);
                        setSpinnerLoading(false);
                        history.push("/completeprofile");
                    }
                    else {
                        setErrorMessage(result.data.message);
                        setSpinnerLoading(false);
                    }
                })
                    .catch(error => {

                    })
            }
            else {
                setErrorMessage('Please Fullfill All Password Conditions');
                setSpinnerLoading(false);
            }
        }
    };
    return (
        <>
            <LSHeader />
            <Helmet>
                <title>Register - Goalstox</title>
                {/* <meta name="keywords" content={pageKeywords}/>  */}
                {/* <meta name="description" content={pageDescription} /> */}
            </Helmet>
            {SYSTEMMAINTAINANCE == 1 ?
                <div class="alert alert-danger" role="alert">
                    SYSTEM UNDER MAINTAINANCE !
                </div> :
                <section>
                    <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
                        <div className='overlay-box'>
                            <Watch
                                color="#ffffff"
                                visible={spinnerLoading}
                            />
                        </div>
                    </div>

                    <div className="container">
                        <div className="login-media align-items-stretch justify-content-center ht-100p">
                            <div className="login-media-img d-none align-items-center d-lg-flex">
                                <div className="mx-wd-600">
                                    <img src="img/login_bg.png" className="img-fluid" alt="" />
                                </div>
                            </div>
                            <div className="sign-wrapper">
                                {
                                    step1 == true ?
                                        <div className="wd-100p">
                                            <h4>Signup now</h4>
                                            <p className="tx-color-03 mg-b-40 tx-13">or check your application status</p>
                                            <div className="form-group">
                                                <label>Email address</label>
                                                <input type="email" name="user_email" value={registerData.user_email} onChange={handleInput} className="form-control" placeholder="yourname@yourmail.com" />
                                                <p className="tx-12 mg-t-5">We will send you OTP on your Email.</p>
                                            </div>
                                            {
                                                errorMessage != '' ? <p className="text text-danger">{errorMessage}</p> : null
                                            }
                                            <button className="btn btn-success button01" onClick={firstStep}><span id="signin">Continue</span></button>
                                            <p className="tx-11 tx-color-03 tx-center mg-t-15 line20">By clicking Create an account below, you agree to our terms of service and privacy statement.</p>
                                            <div className="mg-t-20 tx-center">Already have an account? <Link to="/login"> Sign In</Link></div>
                                        </div> : null
                                }
                                {
                                    step2 == true ?
                                        <div className="wd-100p">
                                            <h5> Verify OTP </h5>
                                            <p className="tx-color-03 mg-b-4 tx-13">Sent to <span id="otp-text">{registerData.user_email}</span> <span onClick={backToEmail} className="tx-theme"> (change email)</span></p>
                                            <div className="form-group">
                                                <label>Enter OTP</label>
                                                <input type="number" name="email_otp" value={registerData.email_otp} onChange={handleInput} />
                                                {
                                                    counter === 0 ?
                                                        <p id="timenew" className="tx-12 mg-t-5"  >Didn't receive OTP? Resend <Link onClick={resendotp}>(Click Here)</Link></p> :
                                                        <p id="timenew" className="tx-12 mg-t-5"  >Resend OTP in {counter} seconds</p>
                                                }
                                                {
                                                    errorMessage != '' ? <p className="text text-danger">{errorMessage}</p> : null
                                                }
                                            </div>
                                            <button className="btn btn-success button01" onClick={secondStep}>Continue</button>
                                        </div> : null
                                }
                                {
                                    step3 == true ?
                                        <div className="wd-100p">

                                            <h5>What's your Mobile Number?</h5>
                                            {/* <p className="tx-color-03 mg-b-4">Test</p>	 */}
                                            <div className="form-group mobile-input">
                                                <label>Enter Mobile Number</label>
                                                <input type="number" name="mobile_no" value={registerData.mobile_no} onChange={handleInput} className="form-control" placeholder="10 digit number" />
                                                <div className="country-code">+91</div>
                                                <p className="tx-12 mg-t-5">We will send you OTP on your Mobile.</p>
                                                {
                                                    errorMessage != '' ? <p className="text text-danger">{errorMessage}</p> : null
                                                }
                                            </div>
                                            <button id="clickbutton" className="btn btn-success button01" onClick={thirdStep}>Continue</button>
                                        </div> : null
                                }
                                {
                                    step4 == true ?
                                        <div className="wd-100p">
                                            <h5>Verify OTP</h5>
                                            <p className="tx-color-03 mg-b-4 tx-13">Sent to <span>{registerData.mobile_no}</span> <span onClick={backToMobile} className="tx-theme"> (change Mobile)</span></p>
                                            <div className="form-group">
                                                <label>Enter OTP</label>
                                                <input type="number" name="mobile_otp" value={registerData.mobile_otp} onChange={handleInput} className="form-control" />
                                                {
                                                    countermob == 0 ?
                                                        <p className="tx-12 mg-t-5"  >Didn't receive OTP? Resend <Link onClick={resendotpmobile}>(Click Here)</Link></p> :
                                                        <p className="tx-12 mg-t-5"  >Resend OTP in {countermob} seconds</p>
                                                }
                                            </div>
                                            {
                                                errorMessage != '' ? <p className="text text-danger">{errorMessage}</p> : null
                                            }
                                            <button id="clickbutton2" className="btn btn-success button01" onClick={forthStep}>{showLoading == true ? <span id="loader"><img style={{ width: '25px' }} src="img/loader.gif" /></span> : 'Continue'}</button>
                                        </div> : null
                                }
                                {
                                    step5 == true ?
                                        <div className="wd-100p">
                                            <div>
                                                <h5>Create Password</h5>
                                                <p className="tx-color-03 mg-b-4 tx-13">Please enter your password</p>
                                                <div className="form-group">
                                                    <label>Password:</label>
                                                    <input type="password" name="password" value={registerData.password} onChange={handleInput} className="form-control" />
                                                </div>
                                                <div className="form-group">
                                                    <label>Confirm Password:</label>
                                                    <input type="password" name="cnfpassword" value={registerData.cnfpassword} onChange={handleInput} className="form-control" />
                                                </div>
                                                <button type="submit" onClick={setsalescode} class="buttonab-line mg-t-20 mg-b-10">Sales Code If Any <i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                                                {salcode == 1 ?
                                                    <div className="form-group">
                                                        <input type="text" name="agentcode" onChange={handleInput} className="form-control" />
                                                        {/* <p className="tx-color-03 mg-b-4 tx-13">(If Available)</p>	 */}

                                                    </div> : ''
                                                }
                                                {
                                                    errorMessage != '' ? <p className="text text-danger">{errorMessage}</p> : null
                                                }
                                                <button className="btn btn-success button01 mg-b-10" onClick={fifthStep}>Submit</button>
                                                <p id="minchar" className="text mg-b-5 tx-11">Minimum 8 characters</p>
                                                <p id="capsmall" className="text mg-b-5 tx-11">Have atleast 1 capital and 1 small alphabet</p>
                                                <p id="specialchar" className="text mg-b-5 tx-11">Have one of the following special characters @,#,$,-,_,%,&,!,?</p>
                                            </div>
                                        </div> : null
                                }
                            </div>
                        </div>
                    </div>
                </section>}
            <Footer />
        </>
    );
}

export default Register;